import React from 'react'
import createIcon from '@/lib/create-icon'

export const CheckCircleSuccessIcon = createIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" fill="#0B947C" stroke="#0B947C" strokeWidth="2" />
    <path d="M17 9L9.30769 16L7 13.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>,
)
